import { debounce, DebouncedFunc } from "lodash";
import { action, flow, flowResult, makeObservable, observable } from "mobx";
import { fetchSearchItems } from "../../../api/ApiManager";
import { ICollection } from "../../../entities/Collection/CollectionTypes";
import { RaffleEntry } from "../../../pages/RaffflePage/types/RafffleTypes";
import BusyStore from "../../../stores/common/BusyStore";

class MainHeaderStore extends BusyStore {
  searchString = "";

  isMenuOpen = false;

  debouncedLoadItems: DebouncedFunc<typeof this.loadItems>;

  searchItems: {
    rafffles: RaffleEntry[];
    collections: ICollection[];
  } = {
    rafffles: [],
    collections: [],
  };

  isSearchResultOpen = false;

  isSearchMobOpen = false;

  isMenuMobOpen = false;

  isCartVisible = false;

  constructor() {
    super();
    makeObservable<MainHeaderStore, "loadItemsFlow">(this, {
      searchString: observable,
      searchItems: observable,
      isSearchResultOpen: observable,
      isSearchMobOpen: observable,
      isMenuMobOpen: observable,
      isMenuOpen: observable,
      isCartVisible: observable,

      setSearchString: action,
      setIsSearchResultOpen: action,
      setIsSearchMobOpen: action,
      setIsMenuMobOpen: action,
      setIsMenuOpen: action,
      setCartVisible: action,

      loadItemsFlow: flow,
    });

    this.debouncedLoadItems = debounce(this.loadItems.bind(this), 1000);
  }

  setIsMenuOpen(isMenuOpen: boolean) {
    this.isMenuOpen = isMenuOpen;
  }

  setCartVisible(status: boolean) {
    this.isCartVisible = status;
  }

  setSearchString(searchString: string) {
    this.debouncedLoadItems.cancel();
    this.searchString = searchString;
    if (searchString.length) {
      this.debouncedLoadItems();
      this.isSearchResultOpen = true;
    } else {
      this.isSearchResultOpen = false;
    }
  }

  setIsSearchResultOpen(isSearchResultOpen: boolean) {
    this.isSearchResultOpen = isSearchResultOpen;
  }

  setIsSearchMobOpen(isSearchMobOpen: boolean) {
    this.isSearchMobOpen = isSearchMobOpen;
  }

  setIsMenuMobOpen(isMenuMobOpen: boolean) {
    this.isMenuMobOpen = isMenuMobOpen;
  }

  loadItems(): Promise<void> {
    return flowResult(this.loadItemsFlow());
  }

  private *loadItemsFlow() {
    this.onLoadingStart();
    try {
      const items: {
        rafffles: RaffleEntry[];
        collections: ICollection[];
      } = yield fetchSearchItems(this.searchString);

      this.searchItems = items;
    } finally {
      this.onLoadingFinished();
    }
  }
}

export default MainHeaderStore;
